import { TagEvent } from 'tag/ts/tag/events/TagEvent';
import { ITagEventDataVO } from 'tag/ts/tag/interfaces/events/ITagEventDataVO';
import { ITagEventVO } from 'tag/ts/tag/interfaces/events/ITagEventVO';
import { ITag } from 'tag/ts/tag/interfaces/ITag';

/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description TagEvent VO
 */
export class TagEventVO implements ITagEventVO {

	/**
	 * @description Event Time in ms from Smart Tag start
	 */
	msFromStart: number;

	/**
	 * @description HH:MM:SS,MS from creation of new SmartTag instance
	 * @type {string}
	 */
	timeFromStart: string;

	type: TagEvent;
	uuid: string;
	tag: ITag;
	data: ITagEventDataVO;
	target: unknown;
	targetName: string;

	constructor(
		type: TagEvent = undefined,
		tag: ITag = undefined,
		data: ITagEventDataVO | any = undefined,
		target: unknown = undefined,
		targetName: string = undefined
	) {
		this.type = type;
		this.uuid = tag?.uuid;
		this.tag = tag;
		this.data = data;
		this.target = target;
		this.targetName = targetName;
	}

	[ key: string ]: unknown;
}